import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { SemCallsV5Component } from '../sem-calls-v5/sem-calls-v5.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { HIGHCHARTS_LEGEND_VERTICAL_ALIGN } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-sem-calls-v3',
	templateUrl: './sem-calls-v3.component.html',
	styleUrls: ['./sem-calls-v3.component.css']
})
export class SemCallsV3Component extends SemCallsV5Component implements OnInit, OnDestroy {
	public callsMaxValue;
	defaultCount: number = 8;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
			this.selectedValue = 1;
		});
	}

	ngOnInit() {
		super.ngOnInit();
	}

	filterChange(value: any) {
		this.selectedValue = value;
		this.generateGraphData(this.graphData);
		this.drawGraph();
	}
	drawGraph() {
		let margin = this.chartConfig.graphConfig.margin ? this.chartConfig.graphConfig.margin : [10, 50, 100, 100];
		Highcharts.chart({
			chart: {
				renderTo: this.graphElement.nativeElement,
				type: 'scatter',
				height: '25%',
				zoomType: 'xy',
				margin: margin
			},
			title: {
				text: null
			},
			subtitle: {
				text: null
			},
			xAxis: {
				tickPositions: this.tickPositions,
				labels: {
					rotation: 45,
					style: {
						color: '#666666',
						fontFamily: 'Source Sans Pro'
					},
					formatter: function () {
						return moment(this.value).format('MM-DD-YYYY');
					}
				},
				startOnTick: true,
				endOnTick: true,
				showFirstLabel: false,
				showLastLabel: false
			},
			tooltip: {
				useHTML: true,
				borderColor: '#cf3339',
				borderWidth: 2,
				style: {
					color: '#666666',
					fontFamily: 'Source Sans Pro'
				},
				formatter: function () {
					return (
						Highcharts.dateFormat('%m/%d/%Y', this.x) +
						'  ' +
						Highcharts.dateFormat('%l:%M:%S %p', this.y) +
						'<br/>' +
						this.point['tooltip']
					);
				}
			},
			yAxis: [
				{
					title: {
						text: 'Time',
						style: {
							color: '#666666',
							fontFamily: 'Source Sans Pro'
						}
					},
					gridLineDashStyle: 'Solid',
					gridLineWidth: 1,
					allowDecimals: false,
					min: 0,
					max: 24 * 3600 * 1000,
					type: 'datetime',
					labels: {
						style: {
							color: '#666666',
							fontFamily: 'Source Sans Pro'
						},
						formatter: function () {
							return Highcharts.dateFormat('%l:%M %p', Number(this.value));
						}
					}
				},
				{
					title: {
						text: ''
					},
					gridLineDashStyle: 'Solid',
					gridLineWidth: 1,
					allowDecimals: false,
					opposite: true
				}
			],
			credits: {
				enabled: false
			},
			plotOptions: {
				series: {
					enableMouseTracking: true,
					keys: ['x', 'y', 'tooltip'],
					events: {
						legendItemClick: (el) => {
							if (el.target['userOptions'].name == 'Answered') {
								this.graphFilterDisabled = el.target.visible;
							}
							if (
								(el.target['userOptions'].name == 'Answered' &&
									el.target.visible &&
									!el.target.chart.legend.allItems[1].visible) ||
								(el.target['userOptions'].name == 'Missed' &&
									el.target.visible &&
									!el.target.chart.legend.allItems[0].visible)
							) {
								el.target.chart.yAxis[0].update({ visible: false });
							} else {
								el.target.chart.yAxis[0].update({ visible: true });
							}
						}
					},
					states: {
						hover: {
							halo: {
								opacity: 0.3
							}
						},
						inactive: {
							opacity: 1
						}
					}
				}
			},
			legend: {
				layout: 'horizontal',
				align: 'center',
				verticalAlign:
					HIGHCHARTS_LEGEND_VERTICAL_ALIGN[this.chartConfig.graphConfig.legendConfig.verticalAlign] || 'bottom',
				floating: false,
				symbolPadding: 5,
				itemWidth: 130,
				itemStyle: {
					fontWeight: 'normal',
					fontFamily: 'Source Sans Pro'
				},
				symbolRadius:
					this.chartConfig.seriesConfig[0].marker && this.chartConfig.seriesConfig[0].marker.symbolRadius
						? this.chartConfig.seriesConfig[0].marker.symbolRadius
						: 12,
				x: 0,
				y: 0
			},
			series: this.graphObj.series
		});
	}
	ngOnDestroy() {
		super.ngOnDestroy();
	}
	downloadCSVData(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns
		);
	}
}
